(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-local"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-local-timer')) {
    customElements.define(
      'countdown-local-timer',
      class LocalTimer extends HTMLElement {
        connectedCallback() {
          this.hours = this.dataset.hours;
          this.minutes = this.dataset.minutes;
          this.display = this.querySelector('.timer-display');
          this.hoursDisplay = this.querySelector('[data-hours]');
          this.minutesDisplay = this.querySelector('[data-minutes]');
          this.secondsDisplay = this.querySelector('[data-seconds]');

          this.completeMessage = this.dataset.completeMessage;

          if (!this.dataset.id) {
            console.warn('<countdown-local-timer> Missing required data-id attribute.');
            return;
          }
          this.storeKey = `local-timer-offset-${this.dataset.id}`;

          this.offset = this.#getStored();
          this.totalSeconds = this.hours * 3600 + this.minutes * 60;

          console.log(this.offset);
          this.init();
        }

        init() {
          setInterval(() => {
            if (!this.timerComplete) {
              this.#calculate();
            }
          }, 1000);

          this.#calculate();
          this.display.classList.add('visible');
        }

        #calculate() {
          const now = Date.now();
          const elapsed = Math.floor((now - this.offset) / 1000);

          let remaining = this.totalSeconds - elapsed;

          if (remaining <= 0) {
            remaining = 0;
            this.timerComplete = true;
            clearInterval(this.interval);
            localStorage.setItem('X25vX2dpZnQ=', 'true');
            if (this.completeMessage) {
              this.innerHTML = `<div style="font-weight:bold;">${this.completeMessage}</div>`;
            }
          }

          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const seconds = remaining % 60;

          this.hoursDisplay.textContent = this.#pad(hours);
          this.minutesDisplay.textContent = this.#pad(minutes);
          this.secondsDisplay.textContent = this.#pad(seconds);
        }

        #pad(num) {
          return String(num).padStart(2, '0');
        }

        #getStored() {
          let stored = JSON.parse(localStorage.getItem(this.storeKey));
          if (stored && stored.expireTime && stored.expireTime <= Date.now()) {
            localStorage.removeItem('X25vX2dpZnQ=');
            localStorage.removeItem(this.storeKey);
            stored = null;
          }

          if (!stored) {
            let value = Date.now();
            if (localStorage.hasOwnProperty('local-timer-offset')) {
              value = parseInt(localStorage.getItem('local-timer-offset'), 10);
              localStorage.removeItem('local-timer-offset');
            }
            stored = {
              value: value,
              expireTime: Date.now() + 7 * 24 * 60 * 60 * 1000,
            };
            localStorage.setItem(this.storeKey, JSON.stringify(stored));
          }
          return parseInt(stored.value, 10);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dealers-form"] && !Shopify.designMode) return;
  try {
    
      if (!customElements.get('dealers-form')) {
        customElements.define(
          'dealers-form',
          class DealersForm extends HTMLElement {
            constructor() {
              super();
              this.onSubmit = this.onSubmit.bind(this);
            }
            connectedCallback() {
              this.modal = document.querySelector(this.getAttribute('data-modal'));
              this.form = this.querySelector('form');
              this.submitter = this.form.querySelector('.submit_button .button[type=submit]');
              this.formError = this.querySelector('.form__error');
              this.form.addEventListener('submit', this.onSubmit);

              this.modal.querySelector('.button.close').addEventListener('click', () => this.modal.hide());
            }

            disconnectedCallback() {
              this.form.removeEventListener('submit', this.onSubmit);
            }

            async onSubmit(evt) {
              evt?.preventDefault();
              if (this.status === 'loading') return;

              this.errorList?.remove();
              this.formError.classList.add('hidden');
              this.form.querySelectorAll('.field__input.error').forEach((i) => i.classList.remove('error'));

              try {
                this.status = 'loading';
                const formData = new FormData(this.form);
                this.submitter.disabled = true;
                const response = await fetch(this.form.action, {
                  method: this.form.method,
                  body: formData,
                });
                if (response.status === 200 || response.status === 400) {
                  const json = await response.json();
                  if (response.status === 200) {
                    if (this.modal) this.modal.show(this);
                    this.form.reset();
                  } else {
                    const errors = json?.error?.fieldErrors || [];
                    let listItems = '';
                    for (const [key, value] of Object.entries(errors)) {
                      const input = this.form.elements[key];
                      input.classList.add('error');
                      listItems += `<li><small>${value[value.length - 1]}</small></li>`;
                    }
                    this.displayError('There were some errors with your form submission', listItems);
                  }
                } else {
                  throw new Error(response.statusText);
                }
              } catch (err) {
                this.displayError(`Error submitting form, please try again`);
              } finally {
                this.status = 'idle';
                this.submitter.disabled = false;
              }
            }

            displayError(message, list) {
              this.formError.querySelector('.error-text').innerHTML = message;
              this.formError.classList.remove('hidden');
              if (list) {
                this.errorList = document.createElement('ul');
                this.errorList.setAttribute('role', 'list');
                this.errorList.className = 'form-status-list';
                this.errorList.innerHTML = list;
                this.formError.after(this.errorList);
              }
            }
          }
        );
      }
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-western"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.classList.contains('overlaid-header'))
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      else document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.header.classList.remove('revealed');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('revealed');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
        'revealed'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (this.classList.contains('overlaid-header'))
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      else document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.header.classList.remove('revealed');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('revealed');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
        'revealed'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-sizing"] && !Shopify.designMode) return;
  try {
    
  class SimpleSizing {
    constructor(section) {
      this.$section = section;

      this.$sizeSelect = section.querySelector('#StandardSizeInput');
      this.$circumferenceSelect = section.querySelector('#FootCircumferenceMeasurement');
      this.$cirSelectOptions = Array.from(this.$circumferenceSelect.querySelectorAll('option'));
      this.$cirSelectOptions.shift();

      this.$lengthLabels = section.querySelectorAll('table .length-label');
      this.$widthLabels = section.querySelectorAll('table .width-label');
      this.$tableCells = section.querySelectorAll('table .opt-td');

      this.$recLengths = section.querySelectorAll('.rec-length');
      this.$recWidths = section.querySelectorAll('.rec-width');
      this.$recLink = section.querySelector('.recommended-size .button');

      this.$recommendedTableLength = section.querySelector('table .length-label.green');
      this.$selectedTableLength = section.querySelector('table .length-label.blue');
      this.$selectedCircumference = section.querySelector('table .opt-td.orange');
      this.selected = {
        size: this.$sizeSelect.value,
        circumference: this.$circumferenceSelect.value,
      };

      const sizeOptTxt = section.querySelector('[data-size-options]')?.innerHTML;
      this.sizeOptions = !!sizeOptTxt ? JSON.parse(sizeOptTxt) : [];

      this.setupListeners();
    }

    setupListeners() {
      this.$sizeSelect.addEventListener('change', (evt) => {
        this.setSize(this.$sizeSelect.value);
      });

      this.$circumferenceSelect.addEventListener('change', (evt) => {
        this.selected.circumference = this.$circumferenceSelect.value;
        this.$selectedCircumference?.classList.remove('orange');
        this.$selectedCircumference = this.$section.querySelector(
          `table .opt-td[data-width="${this.selected.circumference}"][data-index="${this.$recommendedTableLength.dataset.index}"]`
        );
        this.$selectedCircumference.classList.add('orange');
        this.setRecommended();
      });

      this.$lengthLabels.forEach((llabel) =>
        llabel.addEventListener('click', () => {
          const length = Number(llabel.dataset.length);
          if (length >= this.sizeOptions[0].size) {
            this.$sizeSelect.value = length;
            this.setSize(length);
          }
        })
      );

      this.$tableCells.forEach((cell) =>
        cell.addEventListener('click', () => {
          if (cell.dataset.index === this.$recommendedTableLength.dataset.index) {
            this.selected.circumference = cell.dataset.width;
            this.$circumferenceSelect.value = this.selected.circumference;
            this.$selectedCircumference?.classList.remove('orange');
            this.$selectedCircumference = cell;
            this.$selectedCircumference.classList.add('orange');
            this.setRecommended();
          }
        })
      );
    }

    setSize(size) {
      this.selected.size = Number(size);
      const sizeOption = this.sizeOptions.find((opt) => opt.size === this.selected.size);
      this.$cirSelectOptions.forEach((opt, idx) => {
        opt.innerText = sizeOption.measurements[idx];
      });

      this.$recommendedTableLength.classList.remove('green');
      this.$selectedTableLength.classList.remove('blue');
      this.$selectedCircumference?.classList.remove('orange');
      const recommendedSize = this.selected.size - 1;

      this.$recommendedTableLength = this.$section.querySelector(
        `table .length-label[data-length="${recommendedSize}"]`
      );
      this.$selectedTableLength = this.$section.querySelector(
        `table .length-label[data-length="${this.selected.size}"]`
      );

      if (this.$selectedCircumference) {
        const circumferenceValue = this.$selectedCircumference.innerText.trim();
        const widthIndex = sizeOption.measurements.findIndex((m) => m === circumferenceValue);
        if (widthIndex >= 0) {
          this.selected.circumference = widthIndex + 1;
          this.$selectedCircumference = this.$section.querySelector(
            `table .opt-td[data-width="${this.selected.circumference}"][data-index="${this.$recommendedTableLength.dataset.index}"]`
          );
        } else {
          this.selected.circumference = null;
          this.$selectedCircumference = null;
          this.$circumferenceSelect.value = '';
        }
      }

      this.$recommendedTableLength.classList.add('green');
      this.$selectedTableLength.classList.add('blue');
      this.$selectedCircumference?.classList.add('orange');
      //find equivalent selected circumference instead of same width?

      this.setRecommended();
    }

    setRecommended() {
      const recommendedLength = Number(this.selected.size) - 1;
      this.$recLengths.forEach((l) => (l.innerHTML = recommendedLength));
      if (this.selected.circumference !== null) {
        const recommendedWidth = this.$widthLabels[Number(this.selected.circumference) - 1].dataset.width;
        this.$recWidths.forEach((w) => (w.innerHTML = recommendedWidth));
        this.$recLink.href = `/pages/stock-lookup?length=${recommendedLength}&width=${recommendedWidth}`;
        this.$recLink.removeAttribute('role');
        this.$recLink.removeAttribute('aria-disabled');
      } else {
        this.$recWidths.forEach((w) => (w.innerHTML = ''));
        this.$recLink.removeAttribute('href');
        this.$recLink.role = 'link';
        this.$recLink.setAttribute('aria-disabled', 'true');
      }
    }
  }

  new SimpleSizing(document.querySelector('.sizing-section'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stock-lookup"] && !Shopify.designMode) return;
  try {
    
  class StockLookup {
    gridOutputMap = new Map();
    currentKey = '';
    fetchQueue = [];

    constructor(container) {
      this.container = container;

      this.$form = container.querySelector('#SizeSelectForm');
      if (!this.$form) return;

      this.$productGrid = container.querySelector('.collection');
      this.$productCountContainerDesktop = container.querySelector('#ProductCountDesktop');
      this.$productCountContainer = container.querySelector('#ProductCount');
      this.$productCountSpinners = container.querySelectorAll('.product-count-vertical .loading__spinner');
      this.$activeLength = container.querySelector('.active-facets .active-length');
      this.$activeWidth = container.querySelector('.active-facets .active-width');

      this.$sortSelect = container.querySelector('#SortBy');
      this.$sortSelectMobile = container.querySelector('#SortBy-mobile');
      this.sortBy = this.$sortSelect ? this.$sortSelect.value : 'manual';

      const sdcmText = container.querySelector('[data-sdcm]')?.innerHTML;
      this.sdcmData = !!sdcmText ? JSON.parse(sdcmText) : [];

      this.moneyFormat = container.dataset.moneyFormat;
      this.pageWidth = container.dataset.pageWidth;
      this.noResultMessage = container.dataset.message;

      const mobileDrawer = container.querySelector('base-drawer.mobile');
      container.querySelectorAll('.active-facets__button').forEach((btn) =>
        btn.addEventListener('click', () => {
          mobileDrawer.open(btn);
        })
      );

      this.init();
    }

    init() {
      const currentParams = new URLSearchParams(window.location.search);
      if (currentParams.has('length') && currentParams.has('width')) {
        const lengthRadio = this.$form.querySelector(`input[name="length"][value="${currentParams.get('length')}"]`);
        const widthRadio = this.$form.querySelector(`input[name="width"][value="${currentParams.get('width')}"]`);
        lengthRadio.checked = true;
        widthRadio.checked = true;
        this.length = currentParams.get('length');
        this.width = currentParams.get('width');
      } else {
        this.length = '9';
        this.width = 'EE';
      }
      this.$activeLength.innerText = `Length: ${this.length}`;
      this.$activeWidth.innerText = `Width: ${this.width}`;

      this.$form.addEventListener('input', (evt) => {
        const target = evt.target;
        if (target.name === 'length') {
          this.length = target.value;
          this.$activeLength.innerText = `Length: ${this.length}`;
        } else if (target.name === 'width') {
          this.width = target.value;
          this.$activeWidth.innerText = `Width: ${this.width}`;
        }
        this.handleLookup();
      });

      this.$sortSelect?.addEventListener('change', (evt) => {
        this.sortBy = evt.target.value;
        this.$sortSelectMobile.value = this.sortBy;
        if (this.currentKey === '') return;
        const currentOutput = this.gridOutputMap.get(this.currentKey);
        const markup = this.buildMarkup(currentOutput.mapped.stock, currentOutput.mapped.seconds);
        this.$productGrid.innerHTML = markup;
      });
      this.$sortSelectMobile?.addEventListener('change', (evt) => {
        this.sortBy = evt.target.value;
        this.$sortSelect.value = this.sortBy;
        if (this.currentKey === '') return;
        const currentOutput = this.gridOutputMap.get(this.currentKey);
        const markup = this.buildMarkup(currentOutput.mapped.stock, currentOutput.mapped.seconds);
        this.$productGrid.innerHTML = markup;
      });

      this.handleLookup();
    }

    handleLookup() {
      const formData = new FormData();
      formData.set('length', this.length);
      formData.set('width', this.width);
      const queryString = new URLSearchParams(formData);
      history.pushState({}, '', `${window.location.pathname}${queryString && '?'.concat(queryString)}`);
      formData.set('sdcm_data', JSON.stringify(this.sdcmData));
      this.setProductGrid(formData);
    }

    async setProductGrid(formData) {
      this.$productCountSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
      this.$productCountContainerDesktop.classList.add('loading');
      this.$productCountContainer.classList.add('loading');
      this.$productGrid.classList.add('loading');
      const mapKey = `${formData.get('length')} / ${formData.get('width')}`;
      this.currentKey = mapKey;
      let gridOutput = this.gridOutputMap.get(mapKey);
      this.fetchQueue.push(mapKey);

      if (gridOutput) {
        gridOutput.markup = this.buildMarkup(gridOutput.mapped.stock, gridOutput.mapped.seconds);
      } else if (!gridOutput) {
        try {
          const response = await fetch(`${routes.app}/stock-lookup`, { method: 'POST', body: formData });
          if (response.status === 401) throw new Error('no session');
          const body = await response.json();
          gridOutput = this.buildProductGrid(body.data || body.products, mapKey);
        } catch (err) {
          console.log(err);
          this.$productGrid.innerHTML = `<div class="message errors"><p>We encountered an error looking this size, please try again.</p></div>`;
          this.$productGrid.classList.remove('loading');
        }
      }

      if (gridOutput) {
        this.$productGrid.innerHTML = gridOutput.markup;
        const countMarkup =
          gridOutput.stockCount > 0 ? `${gridOutput.stockCount} product${gridOutput.stockCount !== 1 ? 's' : ''}` : '';
        this.$productCountContainerDesktop.innerHTML = countMarkup;
        this.$productCountContainer.innerHTML = countMarkup;

        if (this.fetchQueue[this.fetchQueue.length - 1] === mapKey) {
          this.$productGrid.classList.remove('loading');
          this.$productCountSpinners.forEach((spinner) => spinner.classList.add('hidden'));
          this.$productCountContainerDesktop.classList.remove('loading');
          this.$productCountContainer.classList.remove('loading');

          this.fetchQueue = [];
        }
      }
    }

    buildProductGrid({ stock, seconds }, key) {
      const mappedProducts = stock.map(this.mapProduct.bind(this));
      const mappedSeconds = seconds.map(this.mapProduct.bind(this));

      const markup = this.buildMarkup(mappedProducts, mappedSeconds);

      const gridOutput = {
        markup,
        stockCount: stock.length,
        mapped: {
          stock: mappedProducts,
          seconds: mappedSeconds,
        },
      };
      this.gridOutputMap.set(key, gridOutput);
      return gridOutput;
    }

    buildMarkup(stock, seconds) {
      const stockSorted = this.sortProducts(stock);
      const secondsSorted = this.sortProducts(seconds);
      const limit = 54;
      const secondsMarkup =
        seconds.length > 0
          ? `<div class="seconds-header">
                <h4>Seconds In Stock</h4>
                <p class="product-count__text text-body">${seconds.length} product${seconds.length !== 1 ? 's' : ''}</p>
              </div>
              <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop">` +
            secondsSorted
              .slice(0, limit)
              .map((s) => s.markup)
              .join('') +
            '</ul>'
          : '';
      return stock.length === 0 && seconds.length === 0
        ? `<div class="loading-overlay gradient"></div><div class="message left"><p>${this.noResultMessage}</p></div>`
        : '<div class="loading-overlay gradient"></div><ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop">' +
            stockSorted
              .slice(0, limit)
              .map((p) => p.markup)
              .join('') +
            '</ul>' +
            secondsMarkup;
    }

    mapProduct(data, index) {
      const secondsProduct = Object.hasOwn(data, 'productType') && data.productType === 'Custom Seconds Boots';
      const product = secondsProduct ? data : data.product;
      const variant = secondsProduct ? data.variants.nodes[0] : data;
      const url = secondsProduct
        ? `https://jkbootswarehouse.com/products/${product.handle}`
        : `/products/${product.handle}?variant=${variant.id.split('/').pop()}`;

      const priceData = this.getPriceData(variant.price, data, variant.salePrice);
      const img = product.featuredMedia?.preview.image;
      const sizes = `(min-width: ${this.pageWidth}px) ${
        (Number(this.pageWidth) - 130) / 4
      }px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)`;
      const imageMarkup = `<img srcset="${this.buildSrcset(img.url, [165, 360, 533, 720, 940]).toString()}" src="${
        this.buildSrcset(img.url, [533])[0]
      }" sizes="${sizes}" alt="${img.altText}" class="motion-reduce" width="${img.width}" height="${img.height}" />`;

      const tagMarkup = secondsProduct
        ? `<div class="card__badge vertical top left"><span class="badge badge--custom">Seconds</span></div>`
        : priceData.sale
        ? `<div class="card__badge vertical top left"><span class="badge badge--sale">Sale</span></div>`
        : '';

      return {
        index,
        id: variant.id,
        title: product.title,
        price: priceData,
        markup: `
          <li class="grid__item scroll-trigger animate--slide-in" data-cascade="" style="--animation-order: ${
            index + 1
          }">
            <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media" style="--ratio-percent: 100%">
                <div class="card__inner color-scheme-3 gradient ratio" style="--ratio-percent: 100%" >
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect">
                      ${imageMarkup}
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading">
                        <a href="${url}" class="full-unstyled-link">
                          ${product.title}
                        </a>
                      </h3>
                    </div>
                    ${tagMarkup}
                  </div>
                </div>

                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading font-body h5 uppercase">
                      <a href="${url}" class="full-unstyled-link" >
                        ${product.title}
                      </a>
                    </h3>
                    <div class="card-information">
                      ${
                        product.shortDescription?.value
                          ? `<div class="caption-large light">${product.shortDescription.value}</div>`
                          : ''
                      }                                          
                      <div class="price${priceData.sale ? ' price--on-sale' : ''}">
                        <div class="price__container">
                          <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span class="price-item price-item--regular"> ${priceData.price} </span>
                          </div>
                          <div class="price__sale">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span>
                              <s class="price-item price-item--regular"> ${
                                priceData.sale ? priceData.price : ''
                              } </s> </span
                            ><span class="visually-hidden visually-hidden--inline">Sale price</span>
                            <span class="price-item price-item--sale price-item--last">
                            ${priceData.sale ? priceData.sale.price : priceData.price}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        `,
      };
    }

    getPriceData(variantPrice, data, vSalePrice) {
      const priceNum =
        Shopify.currency.active === 'USD' ? variantPrice : Math.ceil(variantPrice * Shopify.currency.rate);
      const price = this.formatMoney(priceNum * 100);
      let salePrice, saleSavings, percentSavings;
      if (vSalePrice) {
        const saleNum = Number(vSalePrice.value.amount);
        salePrice = Shopify.currency.active === 'USD' ? saleNum : Math.ceil(saleNum * Shopify.currency.rate);
        saleSavings = priceNum - saleNum;
      } else if (data.sale_data) {
        const saleData = data.sale_data;
        percentSavings = saleData.savings;
        if (saleData.type === 'percentage') {
          const savingPercentage = (100 - saleData.savings) / 100;
          salePrice = Math.ceil(priceNum * savingPercentage * 100) / 100;
          saleSavings = priceNum - salePrice;
        } else {
          saleSavings =
            Shopify.currency.active === 'USD' ? saleData.savings : Math.ceil(saleData.savings * Shopify.currency.rate);
          salePrice = priceNum - saleSavings;
        }
      } else if (data.productType === 'Custom Seconds Boots' && data.discount?.value) {
        percentSavings = parseFloat(data.discount.value);
        const percentage = percentSavings ? Number(100 - percentSavings) / 100 : null;
        salePrice = Math.ceil(priceNum * percentage * 100) / 100;
        saleSavings = priceNum - salePrice;
      }

      const sale =
        salePrice && saleSavings
          ? {
              priceNum: salePrice,
              price: this.formatMoney(salePrice * 100),
              savingsNum: saleSavings,
              savings: this.formatMoney(saleSavings * 100),
            }
          : null;

      return {
        priceNum,
        price,
        sale,
      };
    }

    formatMoney(number) {
      let value;
      if (isNaN(number) || number == null) {
        value = 0;
      } else {
        number = (number / 100.0).toFixed(2);
        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ',');
        const centsAmount = parts[1] ? '.' + parts[1] : '';
        value = dollarsAmount + centsAmount;
      }
      return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, value);
    }

    buildSrcset(path, widths) {
      const imageUrls = widths.map((width) => {
        return `${path}${path.indexOf('?') === -1 ? '?' : '&'}width=${width} ${width}w`;
      });
      return imageUrls;
    }

    sortProducts(products) {
      if (this.sortBy === 'title-ascending') {
        return products.sort((a, b) => a.title.localeCompare(b.title));
      } else if (this.sortBy === 'title-descending') {
        return products.sort((a, b) => b.title.localeCompare(a.title));
      } else if (this.sortBy.includes('price')) {
        return products.sort((a, b) => {
          const priceA = Number(a.price.sale ? a.price.sale.priceNum : a.price.priceNum);
          const priceB = Number(b.price.sale ? b.price.sale.priceNum : b.price.priceNum);
          return this.sortBy === 'price-ascending' ? priceA - priceB : priceB - priceA;
        });
      } else {
        return products.sort((a, b) => a.index - b.index);
      }
    }
  }

  new StockLookup(document.querySelector('.stock-lookup'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  class ConfirmPopover extends HTMLElement {
    constructor() {
      super();
      this.close = this.close.bind(this);
      this.confirm = this.confirm.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onResize = this.onResize.bind(this);
      this.isOpen = false;
    }
    connectedCallback() {
      this.$closer = this.querySelector('.js-close');
      this.$confirm = this.querySelector('.js-confirm');
      this.$closer.addEventListener('click', this.close);
      this.$confirm.addEventListener('click', this.confirm);
    }
    disconnectedCallback() {
      this.$closer.removeEventListener('click', this.close);
      this.$confirm.removeEventListener('click', this.confirm);
    }
    open(source, confirmCallback) {
      this.confirmCallback = confirmCallback;
      this.activeSource = source;
      this.activeSource.setAttribute('aria-expanded', true);

      this.classList.add('open');
      const rect = source.getBoundingClientRect();
      const wts = this.offsetWidth - rect.width;
      this.style.top = `${rect.bottom + window.scrollY + 4}px`;
      this.style.left = `${rect.left - wts}px`;
      this.style.right = 'auto';
      this.isOpen = true;

      setTimeout(() => {
        trapFocus(this, this);
      }, 100);
      this.bindOpenEvents();
    }

    close(evt) {
      if (!this.isOpen) return;
      if (evt && !evt.target.closest('.js-close') && evt.target.closest('confirm-popover')) return;

      this.classList.remove('open');
      this.style = '';
      if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
        this.activeSource.setAttribute('aria-expanded', 'false');
        this.activeSource.focus();
      }
      this.isOpen = false;
      removeTrapFocus(this);
      this.unbindOpenEvents();
    }
    async confirm(evt) {
      evt?.stopPropagation();
      if (this.confirmCallback) {
        this.$confirm.disabled = true;
        this.$confirm.classList.add('loading');
        const spinner = this.$confirm.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');
        try {
          const result = this.confirmCallback();
          if (result instanceof Promise) {
            await result;
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.$confirm.disabled = false;
          this.$confirm.classList.remove('loading');
          spinner?.classList.add('hidden');
        }
      }
      this.close();
    }
    onKeyUp(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }
    onResize() {
      debounce(
        function () {
          this.close();
        }.bind(this),
        100
      );
    }
    bindOpenEvents() {
      this.addEventListener('keyup', this.onKeyup);
      window.addEventListener('resize', this.onResize);
      document.documentElement.addEventListener('click', this.close);
    }
    unbindOpenEvents() {
      this.removeEventListener('keyup', this.onKeyup);
      window.removeEventListener('resize', this.onResize);
      document.documentElement.removeEventListener('click', this.close);
    }
  }

  customElements.define('confirm-popover', ConfirmPopover);

  class WishlistSection extends HTMLElement {
    items = [];
    constructor() {
      super();
      this.$itemList = this.querySelector('.wishlist-items');
      this.$itemCount = this.querySelector('.item-count');
      this.$itemTotal = this.querySelector('.wishlist-total');
      this.$templateMarkup = this.querySelector('[data-markup]');
      this.$confirmPopover = this.querySelector('confirm-popover');
      this.$clearListButton = this.querySelector('.list-clear');
      const sdcmText = this.querySelector('[data-sdcm]')?.innerHTML;
      this.sdcmData = !!sdcmText ? JSON.parse(sdcmText) : [];
    }

    connectedCallback() {
      if (!window.jk || !window.jk.Wishlist) {
        document.addEventListener('wishlist:loaded', this.init.bind(this));
      } else {
        this.init();
      }
    }
    init() {
      if (window.jk.Wishlist.items.length === 0) {
        this.buildEmptyList();
      } else {
        this.$confirmClearBtn = document.querySelector('.wishlist-clear-modal .wishlist-clear');
        this.$confirmClearBtn?.addEventListener('click', this.clearAllItems.bind(this));
        this.buildItems();
      }
    }

    buildEmptyList() {
      this.$itemList.innerHTML = this.$templateMarkup.content.children[0].outerHTML;
      this.$itemList.classList.remove('loading');
      this.$itemCount.innerHTML = '0 Items';
    }

    async buildItems() {
      try {
        const response = await fetch(`${routes.app}/wishlist`, {
          method: 'POST',
          body: JSON.stringify({ items: jk.Wishlist.items }),
          headers: { 'Content-Type': 'application/json' },
        });
        const { data } = await response.json();
        if (response.status === 200) {
          let totalPrice = 0;
          this.items = [];
          this.$itemList.innerHTML = '';
          data.forEach((item) => {
            const mapped = this.mapItem(item);
            if (mapped) {
              this.items.push(mapped);
              totalPrice += mapped.priceData.sale ? mapped.priceData.sale.saleNum : mapped.priceData.priceNum;
              this.$itemList.appendChild(mapped.itemEl);
            }
          });
          if (this.items.length > 0) {
            this.$itemTotal.innerHTML = Shopify.formatMoney(totalPrice * 100);
            this.$itemCount.innerHTML = `${this.items.length} Item${this.items.length === 1 ? '' : 's'}`;
            this.$clearListButton.disabled = false;
            this.$itemList.classList.remove('loading');
          } else {
            this.buildEmptyList();
          }
        } else {
          throw Error('Response status', response.status);
        }
      } catch (err) {
        console.error(err);
        this.$itemList.innerHTML = this.$templateMarkup.content.children[1].outerHTML;
        this.$itemList.classList.remove('loading');
      }
    }

    async clearAllItems() {
      this.$confirmClearBtn.disabled = true;
      const result = await jk.Wishlist.clear(this.items.map((i) => i.itemKey));
      this.$confirmClearBtn.closest('modal-dialog')?.hide();
      this.$confirmClearBtn.disabled = true;
      this.clearDisplay();
    }

    clearDisplay() {
      this.$clearListButton.disabled = true;
      this.$itemTotal.innerHTML = '';
      this.buildEmptyList();
    }

    recalcItems() {
      let totalPrice = 0;
      this.items.forEach((item) => {
        totalPrice += item.priceData.sale ? item.priceData.sale.saleNum : item.priceData.priceNum;
      });
      this.$itemTotal.innerHTML = Shopify.formatMoney(totalPrice * 100);
      this.$itemCount.innerHTML = `${this.items.length} Item${this.items.length === 1 ? '' : 's'}`;
    }

    mapItem(item) {
      if (!item) return null;
      const product = item.product;
      const collections = product.collections.nodes.map((c) => ({ id: c.id.split('/').pop(), handle: c.handle }));
      const itemId = item.id.split('/').pop();
      const itemKey = `${product.id.split('/').pop()}:${itemId}`;
      const url = `/products/${product.handle}?variant=${itemId}`;

      const saleData = this.sdcmData.find((s) => collections.some((c) => c.id === s.id));
      const priceData = this.getPriceData(item.price, saleData, item.salePrice);
      const imageMarkup = this.buildImageMarkup(item.image, product);
      const { inventoryText, inventoryColor, variantName, showInventory } = this.getVariantDetails(item, collections);

      const itemEl = document.createElement('div');
      itemEl.className = 'wishlist-item';
      itemEl.innerHTML = `
        <a href="${url}" class="item-image">${imageMarkup}</a>
        <div class="item-details">
            <a class="product-title link" href="${url}">${product.title}</a>
            <div class="variant-title">${variantName}</div>
            ${
              inventoryText === 'Sold out'
                ? '<span class="badge price__badge-sold-out">Sold out</span>'
                : showInventory
                ? `<div class="inventory"><span class="svg-wrapper" style="color:${inventoryColor}">${this.$templateMarkup.content.children[3].outerHTML}</span>${inventoryText}</div>`
                : ''
            }
            <div class="price${priceData.sale ? ' price--on-sale' : ''}">
                <div class="price__container">
                    <div class="price__regular">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span class="price-item price-item--regular"> ${priceData.price} </span>
                    </div>
                    <div class="price__sale">
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <span>
                        <s class="price-item price-item--regular"> ${priceData.sale ? priceData.price : ''} </s> </span
                    ><span class="visually-hidden visually-hidden--inline">Sale price</span>
                    <span class="price-item price-item--sale price-item--last">
                    ${priceData.sale ? priceData.sale.price : priceData.price}
                    </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="item-actions">
          <a href="${url}" class="button button--small">View&nbsp;product</a>
          <button
            class="item-remove button button--secondary button--small"
            type="button"
            title="Remove"
            aria-label="Remove"
          >
            ${this.$templateMarkup.content.children[2].outerHTML}
            <span>Remove</span>
          </button>
        </div>
      `;

      const removeBtn = itemEl.querySelector('.item-remove');
      removeBtn?.addEventListener('click', async (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.$confirmPopover.open(removeBtn, async () => {
          const removed = await jk.Wishlist.remove(itemKey);
          if (removed) {
            const itemIdx = this.items.findIndex((i) => i.itemKey === itemKey);
            if (itemIdx < 0) return;
            const toRemove = this.items.splice(itemIdx, 1)[0];
            toRemove.itemEl.remove();

            if (this.items.length === 0) {
              this.clearDisplay();
            } else {
              this.recalcItems();
            }
          }
        });
      });

      return {
        id: itemId,
        itemKey,
        priceData,
        itemEl,
      };
    }

    getPriceData({ amount, currencyCode }, saleData, salePriceMetafield) {
      const priceNum =
        Shopify.currency.active === currencyCode ? Number(amount) : Math.ceil(Number(amount) * Shopify.currency.rate);
      const price = Shopify.formatMoney(priceNum * 100);
      const result = { priceNum, price };
      if (salePriceMetafield) {
        const salePriceJSON = JSON.parse(salePriceMetafield.value);
        const saleNum = Number(salePriceJSON.amount);
        const salePrice =
          Shopify.currency.active === salePriceJSON.currency_code
            ? saleNum
            : Math.ceil(saleNum * Shopify.currency.rate);
        const saleSavings = priceNum - saleNum;
        result.sale = {
          saleNum: salePrice,
          price: Shopify.formatMoney(salePrice * 100),
          savings: Shopify.formatMoney(saleSavings * 100),
        };
      } else if (saleData) {
        let salePrice, saleSavings;
        if (saleData.type === 'percentage') {
          const savingPercentage = (100 - saleData.amount) / 100;
          salePrice = Math.ceil(priceNum * savingPercentage * 100) / 100;
          saleSavings = priceNum - salePrice;
        } else {
          saleSavings =
            Shopify.currency.active === 'USD' ? saleData.amount : Math.ceil(saleData.amount * Shopify.currency.rate);
          salePrice = priceNum - saleSavings;
        }
        result.sale = {
          saleNum: salePrice,
          price: Shopify.formatMoney(salePrice * 100),
          savings: Shopify.formatMoney(saleSavings * 100),
        };
      }
      return result;
    }

    buildImageMarkup(image, product) {
      const srcset = [165, 360, 533].map(
        (width) => `${image.url}${image.url.indexOf('?') === -1 ? '?' : '&'}width=${width} ${width}w`
      );
      const src = `${image.url}${image.url.indexOf('?') === -1 ? '?' : '&'}width=360 360w`;
      return `<img srcset="${srcset}" src="${src}" sizes="150px" alt="${
        image.altText || product.title
      }" class="motion-reduce" />`;
    }

    getVariantDetails(variant, collections) {
      let inventoryText = 'Sold out',
        inventoryColor = 'rgb(62, 214, 96)';
      if (variant.availableForSale && variant.quantityAvailable > 0) {
        inventoryText = 'In stock';
        if (variant.quantityAvailable < 6) {
          inventoryText = 'Low stock';
          inventoryColor = 'rgb(238, 148, 65)';
        }
      } else if (variant.availableForSale && variant.quantityAvailable < 1) {
        inventoryText = 'In production';
        inventoryColor = 'rgb(200, 200, 200)';
      }
      const variantName = variant.title !== 'Default Title' ? variant.title : '';
      const showInventory =
        collections.some((c) => ['stocked-boots', 'non-stocked-boots', 'heavy-duty-belts'].includes(c.handle)) ||
        inventoryText !== 'In production';
      return {
        inventoryText,
        inventoryColor,
        variantName,
        showInventory,
      };
    }
  }

  customElements.define('wishlist-section', WishlistSection);

  } catch(e) { console.error(e); }
})();
})();
